<template>
    <div
        class="CCopyLink mt-4 flex h-10 w-full flex-row items-center rounded-md border border-solid border-gray-200 dark:border-default bg-white dark:bg-surface-card"
    >
        <input
            id="url"
            class="min-w-0 w-full bg-transparent px-2 outline-none dark:text-txt-body"
            name="url"
            readonly
            type="text"
            :value="props.sharedUrl"
        />
        <div
            class="flex aspect-square h-full shrink-0 cursor-pointer flex-row items-center justify-center border-l border-solid border-gray-200 bg-gray-200 hover:bg-gray-400 focus:bg-gray-600 dark:border-default dark:bg-subtle dark:hover:bg-subtle dark:focus:bg-subtle"
            @click="copyUrl"
        >
            <CIcon
                v-if="!clicked"
                class="size-6 text-black dark:text-white transition-all duration-150 ease-in-out"
                name="content-copy"
            />
            <CIcon v-if="clicked" class="size-6 animate-pulse text-green-400" name="checkmark" />
        </div>
    </div>
</template>

<script setup lang="ts">
import CIcon from '@/components/ui/CIcon.vue'
import { ref } from 'vue'

interface Props {
    sharedUrl: string
}

const props = defineProps<Props>()
const clicked = ref(false)

const copyUrl = () => {
    clicked.value = true
    setTimeout(() => {
        clicked.value = false
    }, 5000)
    navigator.clipboard.writeText(props.sharedUrl)
}
</script>
